import { E_RISK_TYPE, IActiveContingentRisk } from 'interfaces';
import { map } from 'lodash/fp';
import { inject } from 'mobx-react';
import { IMobxRootState } from 'RootStore';
import { RiskPickerItem } from './RiskPicker';
import RiskPickerList from './RiskPickerList';
import riskStore from '../../stores/RisksStore';
import { FGStack, FGStackItem, FGTile } from '@fg/design-system';
import RiskPickerHeader from './RiskPickerHeader';

type RiskPickerContingentProps = {
    selectedRisks?: number[];
    activeContingentRisks?: IActiveContingentRisk[];
    onClose: () => void;
};

export const RiskPickerContingent = inject(
    ({ risksStore }: IMobxRootState) => {
        return {
            selectedRisks: risksStore.currentList,
            activeContingentRisks: riskStore.contingentRisks,
        };
    }
)(
    ({
        selectedRisks,
        activeContingentRisks,
        onClose,
    }: RiskPickerContingentProps) => {
        //todo: memo
        const getContingentItems = (): RiskPickerItem[] => {
            return map(
                risk => ({
                    ...risk,
                    disabled: riskStore.checkIfRiskDisabled(
                        E_RISK_TYPE.CONTINGENT,
                        [risk.id]
                    ),
                }),
                activeContingentRisks
            );
        };

        //todo: memo()
        const onItemClick = (riskId: number) => {
            riskStore.currentStore.overrideValues(riskId);
        };

        return (
            <FGStack className="new-risk-picker-container">
                <FGTile
                    padding="none"
                    appearance="secondary"
                    fullHeight
                    className="new-risk-picker-container-tile">
                    <div
                        style={{
                            //todo: use absolute
                            position: 'absolute',
                            top: 0,
                            bottom: 0,
                            left: 4,
                            right: 4,
                        }}>
                        <FGStack direction="column">
                            <FGStackItem>
                                <RiskPickerHeader onClose={onClose} />
                            </FGStackItem>
                            <FGStackItem>
                                <RiskPickerList
                                    items={getContingentItems()}
                                    onItemClick={onItemClick}
                                    selectedItemsIds={selectedRisks}
                                />
                            </FGStackItem>
                        </FGStack>
                    </div>
                </FGTile>
            </FGStack>
        );
    }
);
